module.exports = __webpack_public_path__ + "img/field_privilege.687b319b.svg";